import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminProjects from "@/pages/admin/AdminProjects";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/projects")({
  head: () => adminHead("Projects | Admin", "Project gallery management.", "/admin/projects"),
  component: () => (
    <ProtectedRoute>
      <AdminProjects />
    </ProtectedRoute>
  ),
});
